import { Link } from "react-router-dom";
import { cases } from "@/mocks/cases";
import { siteTimeline } from "@/mocks/site";

const formatDate = (value: string) => value.replace(/-/g, ".");

const ArchiveTimeline = () => {
  const latest = [...cases]
    .sort((a, b) => (a.fallDate < b.fallDate ? 1 : -1))
    .slice(0, 4);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
        <div className="lg:col-span-5">
          <p className="text-sm font-medium text-primary-600 mb-2">档案进度</p>
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950">
            档案局是怎么搭起来的
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            从一个手工整理的表格，到现在成体系的事件档案库，我们把每一步都记下来了。
          </p>

          <ol className="mt-8 relative">
            <span className="absolute left-[7px] top-2 bottom-2 w-px bg-background-300" aria-hidden="true" />
            {siteTimeline.map((item) => (
              <li key={item.month} className="relative pl-8 pb-7 last:pb-0">
                <span className="absolute left-0 top-1.5 w-4 h-4 rounded-full bg-background-50 border-2 border-primary-500" />
                <p className="font-label text-xs font-bold text-primary-600 tracking-wide">
                  {item.month}
                </p>
                <h3 className="mt-1 font-heading font-bold text-base text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </li>
            ))}
          </ol>
        </div>

        <div className="lg:col-span-7">
          <div className="bg-background-100 border border-background-200/80 rounded-lg p-5 md:p-8">
            <div className="flex items-center justify-between mb-6">
              <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-950 flex items-center gap-2">
                <i className="ri-time-line text-accent-500" />
                最新归档时间线
              </h3>
              <Link
                to="/cases"
                className="text-sm font-medium text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                全部
              </Link>
            </div>

            <div className="space-y-3">
              {latest.map((item) => (
                <Link
                  key={item.id}
                  to={`/cases/${item.slug}`}
                  className="group flex items-center gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200/80 hover:border-primary-300 transition-colors"
                >
                  <span className="hidden sm:flex w-20 shrink-0 font-label text-xs font-bold text-foreground-500">
                    {formatDate(item.fallDate)}
                  </span>
                  <img
                    src={item.avatar}
                    alt={`${item.name} 头像`}
                    className="w-11 h-11 rounded-full object-cover border border-background-200 shrink-0"
                  />
                  <span className="min-w-0 flex-1">
                    <span className="block font-heading font-bold text-base text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                      {item.name}
                    </span>
                    <span className="block text-xs text-foreground-500 truncate">
                      {item.category} · {item.platform}
                    </span>
                  </span>
                  <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-500 transition-colors" />
                </Link>
              ))}
            </div>

            <p className="mt-6 text-xs text-foreground-500 leading-relaxed">
              时间线节点均标注日期与来源类型，点击即可进入对应事件的完整档案。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArchiveTimeline;